// import React, { useState } from "react";
// import { Button } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";

// const LiveStatus = ({
//   username,
//   onLogout,
//   employees,
//   loading,
//   error,
//   onRefresh,
//   companies,
//   setSelectedCompany
// }) => {
//   const navigate = useNavigate();
//   const [expandedAddresses, setExpandedAddresses] = useState({});
//   const [viewMode, setViewMode] = useState("card");
//   const [searchText, setSearchText] = useState("");

//   const fallbackImage = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjUwIiBmaWxsPSIjRjNGNEY2Ii8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMzUiIHI9IjE1IiBmaWxsPSIjQzRDNEM0Ii8+CjxwYXRoIGQ9Ik0yMCA4NWgzNHY2SDR2LTZoMzR2NnoiIGZpbGw9IiNDNEM0RDQiLz4KPHBhdGggZD0iTTMwIDgwaDE0djEwaC0xNFY4MHoiIGZpbGw9IiNDNEM0RDQiLz4KPHBhdGggZD0iTTUwIDgwaDE0djEwaC0xNFY4MHoiIGZpbGw9IiNDNEM0RDQiLz4KPC9zdmc+";

//   const handleRefresh = () => onRefresh(true);

//   const toggleAddress = (id) => {
//     setExpandedAddresses((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleEmployeeClick = (companyName) => {
//     if (setSelectedCompany) {
//       setSelectedCompany(companyName);
//     }
//     navigate("/company");
//   };

//   const renderAddress = (address, id) => {
//     const MAX = 50;
//     if (!address) return "N/A";

//     if (address.length <= MAX) return address;

//     const short = address.substring(0, MAX) + "...";

//     return (
//       <span>
//         {expandedAddresses[id] ? address : short}
//         <button
//           className="btn btn-link p-0 ms-1"
//           style={{ fontSize: "0.8rem", color: "#5a2eca" }}
//           onClick={() => toggleAddress(id)}
//         >
//           {expandedAddresses[id] ? "See less" : "See more"}
//         </button>
//       </span>
//     );
//   };

//   let presentEmployees = employees.filter((e) => e.status === "Present");

//   if (searchText.trim() !== "") {
//     const q = searchText.toLowerCase();
//     presentEmployees = presentEmployees.filter(emp =>
//       emp.address?.toLowerCase().includes(q) ||
//       emp.company_name?.toLowerCase().includes(q) ||
//       emp.name?.toLowerCase().includes(q)
//     );
//   }

//   return (
//     <div
//       className="d-flex flex-column min-vh-100"
//       style={{
//         fontFamily: "Inter, system-ui, sans-serif",
//         background: "linear-gradient(to bottom,#ffffff,#eef1f7)",
//         color: "#212529",
//       }}
//     >
//       {/* HEADER */}
//       <header
//         className="bg-white shadow-sm"
//         style={{
//           padding: "8px 0",
//           borderBottom: "1px solid rgba(0,0,0,0.08)",
//           position: "static",
//           top: 0,
//           zIndex: 20,
//         }}
//       >
//         <div className="container-fluid d-flex justify-content-between align-items-center px-3">
//           <h4 className="text-primary fw-bold m-0">
//             <i className="fas fa-broadcast-tower me-2"></i>
//             Live Status
//           </h4>
          
//           <div className="mb-3 d-flex justify-content-between align-items-center">
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search employee..."
//               style={{ width: 250 }}
//               value={searchText}
//               onChange={(e) => setSearchText(e.target.value)}
//             />
//           </div>

//           <div className="d-flex gap-2">
//             <button
//               className="btn btn-outline-primary btn-sm shadow-sm"
//               style={{ borderRadius: "8px" }}
//               onClick={() => setViewMode(viewMode === "card" ? "table" : "card")}
//             >
//               {viewMode === "card" ? (
//                 <>
//                   <i className="fas fa-table me-1"></i>Table
//                 </>
//               ) : (
//                 <>
//                   <i className="fas fa-th-large me-1"></i>Cards
//                 </>
//               )}
//             </button>

//             <button
//               className="btn btn-primary btn-sm shadow-sm"
//               style={{ borderRadius: "8px" }}
//               onClick={handleRefresh}
//               disabled={loading}
//             >
//               <i className="fas fa-sync-alt me-1"></i>
//               {loading ? "..." : "Refresh"}
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* MAIN CONTENT */}
//       <main style={{ flex: 1 }}>
//         <div className="container-fluid py-4 px-3">
//           {loading ? (
//             <div className="text-center py-5">
//               <div className="spinner-border text-primary" style={{ width: 50, height: 50 }}></div>
//               <p className="mt-3 text-muted fw-semibold">
//                 Checking live attendance...
//               </p>
//             </div>
//           ) : error ? (
//             <div className="alert alert-danger shadow-sm">{error}</div>
//           ) : presentEmployees.length === 0 ? (
//             <h5 className="text-center text-muted py-4">
//               No employees are currently present.
//             </h5>
//           ) : viewMode === "table" ? (
//             <div className="table-responsive shadow-sm rounded bg-white p-3">
//               <table className="table table-hover align-middle">
//                 <thead className="table-primary">
//                   <tr>
//                     <th>Photo</th>
//                     <th>Name</th>
//                     <th>Company</th>
//                     <th>Address</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {presentEmployees.map((emp) => (
//                     <tr 
//                       key={emp.id}
//                       style={{ cursor: "pointer" }}
//                       onClick={() => handleEmployeeClick(emp.company_name)}
//                     >
//                       <td>
//                         <img
//                           src={emp.imageUrl || fallbackImage}
//                           alt=""
//                           className="rounded-circle shadow-sm"
//                           style={{ width: 45, height: 45, objectFit: "cover" }}
//                           onError={(e) => { e.target.src = fallbackImage; }}
//                         />
//                       </td>
//                       <td className="fw-semibold">{emp.name}</td>
//                       <td>{emp.company_name}</td>
//                       <td>{renderAddress(emp.address, emp.id)}</td>
//                       <td>
//                         <span className="badge bg-success px-3 py-2">
//                           Present
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           ) : (
//             <div className="row g-4">
//               {presentEmployees.map((emp, index) => (
//                 <div
//                   key={emp.id}
//                   className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleEmployeeClick(emp.company_name)}
//                 >
//                   <div
//                     className="card shadow-sm border-0 h-100"
//                     style={{
//                       borderRadius: "16px",
//                       background: "#ffffff",
//                       transition: "0.25s",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = "translateY(-6px)";
//                       e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.12)";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.08)";
//                     }}
//                   >
//                     <div className="card-body text-center p-3">
//                       <img
//                         src={emp.imageUrl || fallbackImage}
//                         alt={emp.name}
//                         className="rounded-circle shadow-sm mb-3"
//                         style={{
//                           width: 75,
//                           height: 75,
//                           objectFit: "cover",
//                         }}
//                         onError={(e) => { e.target.src = fallbackImage; }}
//                       />
//                       <h6 className="fw-bold">{emp.name}</h6>
//                       <p className="text-muted small mb-2">
//                         {renderAddress(emp.address, emp.id)}
//                       </p>
//                       <span className="badge bg-success px-3 py-2 mt-2">
//                         Present
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default LiveStatus;

import React, { useState } from "react";

const LiveStatus = ({
  username,
  employees,
  loading,
  error,
  onRefresh,
}) => {
  const [searchText, setSearchText] = useState("");
  const [expandedAddresses, setExpandedAddresses] = useState({});

  const handleRefresh = () => onRefresh(true);

  const toggleAddress = (id) => {
    setExpandedAddresses((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const renderAddress = (address, id) => {
    const MAX = 50;
    if (!address) return "N/A";
    if (address.length <= MAX) return address;
    return (
      <span>
        {expandedAddresses[id] ? address : address.substring(0, MAX) + "..."}
        <button
          className="btn btn-link p-0 ms-1"
          style={{ fontSize: "0.8rem", color: "#5a2eca" }}
          onClick={() => toggleAddress(id)}
        >
          {expandedAddresses[id] ? "See less" : "See more"}
        </button>
      </span>
    );
  };

  let presentEmployees = employees.filter((e) => e.status === "Present");

  if (searchText.trim() !== "") {
    const q = searchText.toLowerCase();
    presentEmployees = presentEmployees.filter(emp =>
      emp.address?.toLowerCase().includes(q) ||
      emp.company_name?.toLowerCase().includes(q) ||
      emp.name?.toLowerCase().includes(q)
    );
  }

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        fontFamily: "Inter, system-ui, sans-serif",
        background: "linear-gradient(to bottom,#ffffff,#eef1f7)",
        color: "#212529",
      }}
    >
      {/* HEADER */}
      <header
        className="bg-white shadow-sm"
        style={{ padding: "8px 0", borderBottom: "1px solid rgba(0,0,0,0.08)" }}
      >
        <div className="container-fluid d-flex justify-content-between align-items-center px-3">
          <h4 className="text-primary fw-bold m-0">
            <i className="fas fa-broadcast-tower me-2"></i>
            Live Status
            {!loading && (
              <span className="ms-2 badge bg-primary" style={{ fontSize: "0.75rem" }}>
                {presentEmployees.length} Present
              </span>
            )}
          </h4>

          <input
            type="text"
            className="form-control"
            placeholder="Search employee..."
            style={{ width: 250 }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <button
            className="btn btn-primary btn-sm shadow-sm"
            style={{ borderRadius: "8px" }}
            onClick={handleRefresh}
            disabled={loading}
          >
            <i className="fas fa-sync-alt me-1"></i>
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main style={{ flex: 1 }}>
        <div className="container-fluid py-4 px-3">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" style={{ width: 50, height: 50 }}></div>
              <p className="mt-3 text-muted fw-semibold">Checking live attendance...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger shadow-sm">{error}</div>
          ) : presentEmployees.length === 0 ? (
            <h5 className="text-center text-muted py-4">
              No employees are currently present.
            </h5>
          ) : (
            <div className="table-responsive shadow-sm rounded bg-white p-3">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-primary">
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Address</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {presentEmployees.map((emp, index) => (
                    <tr key={emp.id}>
                      <td className="text-muted" style={{ fontSize: "0.85rem" }}>
                        {index + 1}
                      </td>
                      <td className="fw-semibold">{emp.name}</td>
                      <td style={{ fontSize: "0.9rem", color: "#6c7ae0" }}>
                        <i className="fas fa-building me-1"></i>
                        {emp.company_name || "—"}
                      </td>
                      <td style={{ fontSize: "0.85rem" }}>
                        {renderAddress(emp.address, emp.id)}
                      </td>
                      <td>
                        <span className="badge bg-success px-3 py-2">Present</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default LiveStatus;